export const submitForm = (formId, submitLock) => async (_, {
  api
}) => api.submitForm(formId, submitLock);